import React from "react";
import "./assets/scss/themes.scss";
import Routing from "./routes/index";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
fakeBackend();

function App() {
  return (
    <React.Fragment>
      <Routing />
    </React.Fragment>
  );
}

export default App;
